export default __webpack_public_path__ + "static/media/16418216953.f840b551.JPG";